export default {
    BASE_URL: "https://api.boexcoin.vip",
    BASE_WSS: "wss://ws.boexcoin.vip",
    BASE_IO: "wss://ws.boexcoin.vip",


    DOMAIN: "https://h5.boexcoin.vip",
    HELP_URL: "https://help.boexcoin.vip"
}
// mexcoin
// export default {
//     BASE_URL: "https://api.mexcoin.vip",
//     BASE_WSS: "wss://ws.mexcoin.vip",
//     BASE_IO: "wss://ws.mexcoin.vip",
//
//
//     DOMAIN: "https://h5.mexcoin.vip",
//     HELP_URL: "https://help.mexcoin.vip"
// }